<div class="card">
    <div class="card-body">
        <!--
        <div class="d-flex align-items-center justify-content-between mb-4">
            <div>
                <h4 class="card-title mb-0">API Tokens</h4>
            </div>
        </div>
        -->
        <api-token-list></api-token-list>
    </div>
</div>
